import styled from 'styled-components';

export const RoundBox = styled.div`
  cursor: default;
  width: 14px;
  height: 14px;
  border-radius: 99px;
  background-color: transparent;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;
